/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidEditorQueryResponse,
  GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidEditorPathParams,
  GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidEditorQueryParams,
  GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidEditor401,
  GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidEditor404,
  GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidEditor500,
} from "../../types/individualPaymentEditorsController/GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidEditor.ts";

function getGetApiV1IndividualpaymentFinancialPeopleFinancialpersonidEditorUrl(
  financialPersonId: GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidEditorPathParams["financialPersonId"],
) {
  const res = {
    method: "GET",
    url: `/api/v1/individualpayment/financial-people/${financialPersonId}/editor` as const,
  };
  return res;
}

/**
 * @description Retorna o plano com totais (transferência, matrícula, pago), telefones separados em DDI+número, descontos com empresa associada, cupom ativo e histórico, endereço de terceiro, cartão mascarado e valores de leitura calculados (mensal/total com descontos, cupom e pontualidade). Os enums do plano vêm com o texto traduzido na cultura da requisição: 'typeText', 'statusText' e 'paymentMethodText'. 404 quando o plano não existe ou a empresa do usuário difere da matrícula. Defaults de criação do legado (não há endpoint próprio): PaymentMethod=Billet, DDI +55, AutomaticGenerateInvoice=true. Migrado do legado IndividualPayment/FinancialPersonEdit GET (GetIndividualPayment). **(Requer Authorization para autenticação)**
 * @summary Retorna os dados completos do plano para o editor (Requer Authorization para autenticação)
 * {@link /api/v1/individualpayment/financial-people/:financialPersonId/editor}
 */
export async function getApiV1IndividualpaymentFinancialPeopleFinancialpersonidEditor(
  financialPersonId: GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidEditorPathParams["financialPersonId"],
  params?: GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidEditorQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidEditorQueryResponse,
    ResponseErrorConfig<
      | GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidEditor401
      | GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidEditor404
      | GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidEditor500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1IndividualpaymentFinancialPeopleFinancialpersonidEditorUrl(
      financialPersonId,
    ).url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}
